import React from 'react'
import Header from '../component/Header'
import { useLocation } from 'react-router-dom';
import ExploreResultLocations from '../component/ExploreResultLocations'
import Footer from '../component/Footer'
import HeroBannerSection from '../component/HeroBannerSection'
import WhyPreQualified from '../component/WhyPreQualified'
import QuestionsCTA from '../component/QuestionsCTA'
import GetPreQualifiedComp from '../component/GetPreQualifiedComp'  
function GetPreQualified() {
   const location = useLocation();
  const hideHero = location.state?.hideHero || false;
  return (
    <>
      <div className='main get-pre-qualified-page'>
        <Header/>
        {!hideHero && <HeroBannerSection />}
        {hideHero && <GetPreQualifiedComp />}
        <WhyPreQualified />
        <QuestionsCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default GetPreQualified


